const mapMembers = (members, type) => members.map(member => ({
  ...member,
  [type]: true,
}))

export default mapMembers
